import { LogonResponse } from "../../../../types/responses";
// import Package from "../../../../package.json";

const LOGIN = {
  CREDENTIALS: `__apps__${process.env.npm_package_name}_credential`,
};

export const webStorePssSaveAuth = (
  logon: LogonResponse,
  rememberMe?: boolean,
) => {
  if (rememberMe) {
    localStorage.setItem("PssLogon", JSON.stringify(logon));
  } else {
    sessionStorage.setItem("PssLogon", JSON.stringify(logon));
  }
};

export const webStorePssGetAuth = (pssAuth: string) => {
  const jsonStr = localStorage.getItem(pssAuth) || "";
  try {
    return JSON.parse(jsonStr);
  } catch (e) {
    return null;
  }
};

export const getLogin = () => {
  return webStorePssGetAuth(LOGIN.CREDENTIALS);
};
